module.exports = __webpack_public_path__ + "img/icon_answer.d495dc5b.svg";